export const DrivesListDlg = {
  "OpenFrom": "Open from {name}",
  "SaveTo": "Save to {name}",
  "OpenFromDrive": "Open from Drive",
  "SaveToDrive": "Save to Drive",
  "TokenExpire": "Token expired, please login again",
  "ReacquireTokenFailed": "Failed to reacquire token, please login again",
  "RemoveAccount": "Do you want to remove this account?",
  "Yes": "Yes",
  "No": "No",
  "OnTeamsTips": "Sorry, we don't support using {name} within Microsoft Teams at this time."
}